import React from 'react';
import { Card, Tabs, Typography, Alert } from 'antd';
import {
  ShoppingCartOutlined,
  WifiOutlined,
  ThunderboltOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';
import { useCognitoAuth } from '../../contexts/CognitoAuthContext';
import { getUserRole } from '../../utils/cognitoUtils';
import { isAdmin } from '../../utils/roleUtils';
import { SalesProvider } from './SalesContext';
import ErrorBoundary from './shared/ErrorBoundary';
import SectionedProductList from './products/SectionedProductList';
import './SalesManager.css';

const { Title, Text } = Typography;

const SalesManagerContent: React.FC = () => {
  const { user } = useCognitoAuth();
  const userRole = user ? getUserRole(user) : '';
  const isAdminUser = isAdmin(userRole);

  if (!isAdminUser) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <Alert
          message="Acesso Negado"
          description="Apenas administradores podem aceder a esta página."
          type="error"
          showIcon
        />
      </div>
    );
  }

  const tabItems = [
    {
      key: 'telecomunicacao',
      label: (
        <span>
          <WifiOutlined />
          Telecomunicação
        </span>
      ),
      children: <SectionedProductList businessArea="telecomunicacao" />
    },
    {
      key: 'energia',
      label: (
        <span>
          <ThunderboltOutlined />
          Energia / Solar
        </span>
      ),
      children: <SectionedProductList businessArea="energia" />
    },
    {
      key: 'seguranca',
      label: (
        <span>
          <SafetyCertificateOutlined />
          Segurança
        </span>
      ),
      children: <SectionedProductList businessArea="seguranca" />
    }
  ];

  return (
    <div className="sales-manager-container">
      <Card className="sales-manager-card" bordered={false}>
        <div className="sales-manager-header">
          <Title level={2} className="sales-manager-title">
            <ShoppingCartOutlined />
            Gestor de Vendas
          </Title>
        </div>

        <Tabs
          defaultActiveKey="telecomunicacao"
          items={tabItems}
        />
      </Card>
    </div>
  );
};

const SalesManager: React.FC = () => {
  return (
    <ErrorBoundary>
      <SalesProvider>
        <SalesManagerContent />
      </SalesProvider>
    </ErrorBoundary>
  );
};

export default SalesManager;
